import Vue from 'vue';
import store from './store';
import ossUpload from '@/assets/script/lib/oss/upload'
import {cookie} from '@deanwu/vue-component-library'

let app = new Vue();

// mes [生产系统]; digital [数据大屏];
const SYS = "digital";
// Alpha [开发环境]; Beta [测试环境]; Preview [预发布环境]; Online [正式环境]
const RE = "Online";
const SERVER_ADDR = (re => {
	switch(re) {
		case 'Local':
		case 'Alpha':
			return '/develop';
		case 'Beta':
			return '/test';
		case 'Preview':
			return '/pre';
		case 'Online':
			return '/api';
	}
})(RE);

export default {
	request: {
		md5Key: 'V52kPpLS6msz7y3NfZUZ9OKFYeoGysMOeMSPdcObi6onvgmgKKEP5gk3s2omhDDOV3T6SYitc5bKUEzZECnEuN61YvObbu2SD7InNlnWeB8j7M195swDhAYjEnLAI71M',
		enKey: 'b2bc2dcff9074d84',
		deKey: '83fe4c23467507cd',
		log: RE != 'Online' || localStorage.getItem('debug') == 1,
		baseUrl: SERVER_ADDR,
		timeout: 60000,
		dataFormatter(data) {
			data.client = 0;
			data.system_client_version_no = store.state.publicConfig ? store.state.publicConfig.system_client_version_no : undefined;
			data.session = store.state.session;
			return data;
		},
		response(data, requestQueue) {
			if (data.code == 9998) {
				if (!window._systemUpdateConfirm) {
					window._systemUpdateConfirm = true;
					app.$confirm({
						message: '检测到新版本已发布，请刷新页面后使用',
						buttonName: '刷新页面',
						cancelButton: false,
						resolve: () => {
							window.location.reload();
						}
					});
				}
				return false;
			}

			let message;
			switch (data.code) {
			case 9403:
			case 9405:
				message = '登录状态已失效，请重新登录';
				break;
			
			case 9505:
				message = '当前账号已在其他设备登录，您已被强制退出，如不是本人操作，请及时修改密码';
				break;
			}
			if (message) {
				if (!window._loginTimeoutConfirm) {
					window._loginTimeoutConfirm = true;
					app.$confirm({
						message,
						buttonName: '重新登录',
						cancelButton: false,
						resolve: () => {
							$app.$store.commit('setSession', '');
							$app.navigateTo(`/login?redirect=${$app.$route.fullPath}`);
							delete window._loginTimeoutConfirm;
						}
					});
				}
				for (let i in requestQueue) {
					requestQueue[i].abort();
				}
				return false;
			}
		}
	},
	
	theme: {
		main: '#00B38A',
		mainHover: '#33C2A1',
		lesser: '#0D6EFE',
		lesserHover: '#3F8FFF',
		adorn: '#FF3333'
	},

	color: {
		white: ['#fff', '#fff'],
		red: ['#FF5555', '#FF3E3E'],
		green: ['#07B461', '#0AB462'],
		blue: ['#0D6EFE', '#2E7FFF'],
		yellow: ['#FFAB17', '#F89E00']
	},
	
	style: {
		unitLine: '#eee',

		buttonSize: {
			normal: {
				'height': '30px',
				'padding': '0 8px'
			},
			search: {
				'height': '32px',
				'border-radius': '2px',
				'padding': '0 10px',
				'font-size': '12px'
			},
			dialog: {
				'border-radius': '2px',
				'box-shadow': '0px 2px 3px 0px rgba(102,102,102,0.15)'
			}
		},
		
		table: {
			border: '#E5E5E5',  // 表格边框色
			headBackground: '#FAFAFA',  // 表头背景色
			rowBorder: '#ddd',  // 行边框色
			rowBorderStyle: 'dotted',  //  行边框类型
			rowEvenBackground: '#fff',
			rowHoverBackground: '#FFF883',  // 行移入背景色
			rowHlBackground: '#FFF883',  // 行选中背景色
			summedBackground: '#F2FFEB'  // 合计行背景色
		}
	},
	
	empty: {
		normal: {
			icon: 'https://cdn.ycmes.cn/static/ycmes/empty.png',
			message: '暂无数据'
		},
	},

	config: {
		title: {
			icon: 'tf-title'
		},

		input: {
			heightResize: {
				type: 'auto',
				maxHeight: '160px'
			}
		},

		file: {
			uploadHandle(files, success) {
				ossUpload(files, {
					success
				});
			}
		},

		table: {
			colEllipsis: true,
			rowClickHl: true
		},
		
		form: {
			breakWhenFail: false
		},

		dialog: {
			maskClose: false,
			maskCloseEvent: 'click'
		},

		layout: {
			gap: 10
		}
	},
	
	data: {
		authority() {
			return store.getters.allAuthKey;
		},
		
		options: {
		},
		
		region(type, pid, resolve) {
			app.request({
				url: '/address_library/region',
				data: {
					parent_id: pid
				},
				success: data => {
					resolve(Array.from(data, item => {
						return {
							name: item.name,
							value: item.id
						}
					}))
				}
			});
		}
	}
}

export {SYS, RE, SERVER_ADDR}